/*eslint-disable*/
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { api_url } from '../../Constants/web_services';
import { selectSignedIn, selectUserData } from '../../Redux/UserSlice';
import img1 from "../../Assets/images/1.png";
import img2 from "../../Assets/images/2.png";
import img3 from "../../Assets/images/3.png";

const JobsScreen = () => {
    const userData = useSelector(selectUserData);
    const isSignedIn = useSelector(selectSignedIn);

    return (
        <div className="aon-contact-area">
            <div className="container">
                <div className="section-head text-center">
                    <h2 className="sf-title">Jobs Searches</h2>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do usmod
                        tempor incididunt ut labore et dolore magna aliqua.
                    </p>
                </div>
                <div className="section-content">
                    <div className="sf-contact-info-wrap">
                        <div className="row">
                            <div className="col-lg-4 col-md-6">
                                <div className="sf-contact-info-box">
                                    <div className="sf-contact-icon">
                                        <span>
                                            <img src={img1} alt="" />
                                        </span>
                                    </div>
                                    <div className="sf-contact-info">
                                        <h4 className="sf-title s-24">Mailing Address</h4>
                                        <p>121 King Street, Melbourne Victoria 3000 Australia</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="sf-contact-info-box">
                                    <div className="sf-contact-icon">
                                        <span>
                                            <img src={img2} alt="" />
                                        </span>
                                    </div>
                                    <div className="sf-contact-info">
                                        <h4 className="sf-title s-24">Email Info</h4>
                                        <p>info@brandcoin.com</p>
                                        <p>support@brandcoin.com</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="sf-contact-info-box">
                                    <div className="sf-contact-icon">
                                        <span>
                                            <img src={img3} alt="" />
                                        </span>
                                    </div>
                                    <div className="sf-contact-info">
                                        <h4 className="sf-title s-24">Phone Number</h4>
                                        <p>0800-123456 (24/7 Support Line)</p>
                                        <p>0800-123654</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sf-contact-form-wrap">
                        <div className="sf-contact-form">
                            <div className="sf-con-form-title text-center">
                                <h2 className="m-b30">Jobs Information</h2>
                            </div>

                        </div>
                        {/*Contact Information End*/}
                    </div>
                </div>
            </div>
        </div>




    )
}

export default JobsScreen